module.exports = __webpack_public_path__ + "static/media/beehive-11.95e2657a.png";